var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParkSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_170_11871",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 39,
    height: 38
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9992 3.50053L3.67835 18.8214C3.36589 19.1339 3.19037 19.5578 3.19037 19.9997C3.19037 20.4416 3.36589 20.8655 3.67835 21.178L19 36.4997C19.3126 36.8121 19.7364 36.9877 20.1783 36.9877C20.6203 36.9877 21.0441 36.8121 21.3567 36.4997L36.6775 21.1789C36.99 20.8663 37.1655 20.4425 37.1655 20.0005C37.1655 19.5586 36.99 19.1347 36.6775 18.8222L21.3558 3.4997C21.0433 3.18724 20.6195 3.01172 20.1775 3.01172C19.7356 3.01172 19.3117 3.18724 18.9992 3.4997V3.50053Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 20H25M20 15V25",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_170_11871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0V0Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkSolid);
export default __webpack_public_path__ + "static/media/park-solid.aa2e0153eb159e32ffb69f780b32cacd.svg";
export { ForwardRef as ReactComponent };